import React, { Component, useState, useRef, useEffect } from "react";
import { Button, TextField, Stack } from "@mui/material";
import axios from "../../features/axiosHelper";

import Dropdown from "@/components/Dropdown/Dropdown";
import IconButton from "@/components/IconButton/IconButton";
import MenuBlock from "../../components/MenuBlock/MenuBlock";
import PopUp from "../../components/PopUp/PopUp";
import PopUpDataGrid from "@/components/DataGrid/PopUpDataGrid";

import "./Notifications.css";
import {
  PlusCircleClicked,
  PlusCircleHover,
  PlusCircleInactive,
} from "../../ImageRepo";

const CreateNewGroupPopUp = ({ onSave, openPopUp, setOpenPopUp }) => {
  const [name, setName] = useState("");

  const onChangeName = (event) => {
    setName(event.target.value);
  };
  const onClickSave = (event) => {
    setName("");
    onSave(name);
    setOpenPopUp(false);
  };

  return (
    <div>
      <PopUp
        size={"small"}
        openPopUp={openPopUp}
        setOpenPopUp={setOpenPopUp}
        title={"Create a New Notification Group"}
      >
        <Stack
          flexDirection={"column"}
          justifyContent={"space-around"}
          style={{ height: "100%" }}
        >
          <div>
            <p>Enter name for new Notification Group</p>
            <TextField
              style={{ marginLeft: "16px" }}
              label={"Enter name"}
              value={name}
              onChange={onChangeName}
            />
          </div>
          <div align="right">
            <Button
              className="btn-primary"
              style={{ width: "120px", marginTop: "12px" }}
              onClick={onClickSave}
            >
              Save
            </Button>
          </div>
        </Stack>
      </PopUp>
    </div>
  );
};
const AddEmailPopUp = ({ onSave, openPopUp, setOpenPopUp }) => {
  const [email, setEmail] = useState("");

  const onChangeName = (event) => {
    setEmail(event.target.value);
  };
  const onClickSave = (event) => {
    onSave(email);
    setEmail("");
    setOpenPopUp(false);
  };

  return (
    <div>
      <PopUp size={"small"} openPopUp={openPopUp} setOpenPopUp={setOpenPopUp}>
        <div className="PopUpContent">
          <div name="top">
            <h1>Add Email Address</h1>
          </div>
          <div name="centre">
            <TextField
              style={{ marginLeft: "16px" }}
              label={"Email Address"}
              value={email}
              onChange={onChangeName}
            />
          </div>
          <div name="bottom" align="right">
            <Button
              className="btn-primary"
              style={{ width: "120px", marginTop: "12px" }}
              onClick={onClickSave}
            >
              Add
            </Button>
          </div>
        </div>
      </PopUp>
    </div>
  );
};
const RemoveEmailPopUp = ({
  onSave,
  openPopUp,
  setOpenPopUp,
  selectedEmails,
}) => {
  const onClickSave = (event) => {
    onSave();
    setOpenPopUp(false);
  };
  return (
    <div>
      <PopUp size={"small"} openPopUp={openPopUp} setOpenPopUp={setOpenPopUp}>
        <Stack
          className="PopUpContent"
          flexDirection={"column"}
          justifyContent={"space-around"}
          style={{ height: "100%" }}
        >
          <div name="top">
            <h1>Confirm Delete Email Addresses</h1>
          </div>
          <div name="centre">
            {selectedEmails.length +
              " email(s) selected. Are you sure you want to delete these emails?"}
          </div>
          <div name="bottom">
            <div style={{ display: "inline-block" }}>
              <Button
                className="btn-primary"
                style={{ width: "80px", marginTop: "12px" }}
                onClick={() => {
                  setOpenPopUp(false);
                }}
              >
                No
              </Button>
            </div>
            <div style={{ display: "inline-block", float: "right" }}>
              <Button
                className="btn-primary"
                style={{ width: "80px", marginTop: "12px" }}
                onClick={onClickSave}
              >
                Yes
              </Button>
            </div>
          </div>
        </Stack>
      </PopUp>
    </div>
  );
};
const NotificationGroups = () => {
  const grid = useRef(null);

  const [mailList, setMailList] = useState([]);
  const [notificationGroups, setNotificationGroups] = useState([]);
  const [notificationMailListId, setNotificationMailListId] = useState(null);
  const [selectedEmails, setSelectedEmails] = useState([]);

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpTitle, setPopUpTitle] = useState(null);

  const [openNewGroupPopUp, setOpenNewGroupPopUp] = useState(false);
  const [openAddEmailPopUp, setOpenAddEmailPopUp] = useState(false);
  const [openRemoveEmailPopUp, setOpenRemoveEmailPopUp] = useState(false);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(false);

  const columnsGroups = [
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 1,
    },
  ];

  const onSelectGroups = (event) => {
    let selected = event.target.value;
    setNotificationMailListId(selected);

    if (selected == -1) {
      //create new group
      setOpenNewGroupPopUp(true);
    }
  };
  const onSaveCreateNewGroup = (name) => {
    let index = notificationGroups.findIndex((x) => x.name == name);
    if (index != -1) {
      alert("Group name is already in use.");

      setNotificationMailListId(
        notificationGroups[index].notificationMailListId
      );
      return;
    }

    let copy = JSON.parse(JSON.stringify(notificationGroups)); //deepcopy since state is readonly
    copy.push({
      notificationMailListId: -2,
      name: name,
      mailList: [],
      jsonMailList: "",
    });
    setNotificationGroups(copy);
    setNotificationMailListId(-2);
    setMailList([]);
  };
  const onSaveAddEmail = (name) => {
    let copy = JSON.parse(JSON.stringify(mailList)); //deepcopy since state is readonly
    copy.push({ id: name, email: name });
    setMailList(copy);
  };
  const onConfirmRemoveEmails = () => {
    let copy = JSON.parse(JSON.stringify(mailList)); //deepcopy since state is readonly
    selectedEmails.forEach((row) => {
      let i = copy.findIndex((x) => x.email == row.email);
      if (i > -1) {
        copy.splice(i, 1);
      }
    });
    setMailList(copy);
  };
  const onClickSaveGroup = () => {
    let copyGroup = JSON.parse(
      JSON.stringify(
        notificationGroups.find(
          (x) => x.notificationMailListId == notificationMailListId
        )
      )
    ); //deepcopy since state is readonly

    copyGroup.jsonMailList = JSON.stringify(mailList.map((x) => x.email));
    setIsSaveBtnDisabled(true);
    axios
      .post("/notifications/groups", null, {
        params: {
          ...copyGroup,
        },
      })
      .then((response) => {
        getNotificationGroups();
        if (notificationMailListId == -2) {
          setNotificationMailListId(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setIsSaveBtnDisabled(false);
      });
  };
  const getMailList = () => {
    if (notificationMailListId != null) {
      let currentMailList = notificationGroups
        .find((x) => x.notificationMailListId == notificationMailListId)
        .emailList.map((x) => {
          return { id: x, email: x };
        });
      setMailList(currentMailList);
    }
  };
  const getNotificationGroups = () => {
    axios
      .get("/notifications/groups")
      .then((response) => {
        let responseData = response.data;
        responseData.push({
          name: "+ Create a New Group",
          notificationMailListId: -1,
          emailList: [],
          jsonMailList: "",
        });
        setNotificationGroups(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getNotificationGroups();
  }, []);

  useEffect(() => {
    getMailList();
  }, [notificationMailListId]);

  return (
    <MenuBlock title="Setup Notification Groups" maxHeight={600}>
      <div className="menuBlockContent">
        <CreateNewGroupPopUp
          openPopUp={openNewGroupPopUp}
          setOpenPopUp={setOpenNewGroupPopUp}
          onSave={onSaveCreateNewGroup}
        ></CreateNewGroupPopUp>
        <AddEmailPopUp
          openPopUp={openAddEmailPopUp}
          setOpenPopUp={setOpenAddEmailPopUp}
          onSave={onSaveAddEmail}
        ></AddEmailPopUp>
        <RemoveEmailPopUp
          openPopUp={openRemoveEmailPopUp}
          setOpenPopUp={setOpenRemoveEmailPopUp}
          selectedEmails={selectedEmails}
          onSave={onConfirmRemoveEmails}
        ></RemoveEmailPopUp>
        <PopUp
          size={"small"}
          openPopUp={popUpMessage != ""}
          setOpenPopUp={() => {
            setPopUpMessage("");
          }}
        >
          <div className="PopUpContent">
            <h1>{popUpTitle}</h1>
            <div>{popUpMessage}</div>
          </div>
        </PopUp>
        <Dropdown
          width={320}
          label="Select Group"
          onChange={onSelectGroups}
          value={notificationMailListId}
          options={notificationGroups.map((x) => {
            return { key: x.notificationMailListId, label: x.name };
          })}
        ></Dropdown>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <h3 style={{ display: "inline-block" }}>Email Address</h3>
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            style={{ width: 100 }}
          >
            <IconButton
              onClick={() => {
                setOpenRemoveEmailPopUp(true);
              }}
              label={"Delete"}
              iconSize={30}
              icon={PlusCircleInactive}
              iconHover={PlusCircleHover}
              iconClicked={PlusCircleClicked}
              hideShadow={true}
              disabled={
                notificationMailListId == null || selectedEmails.length == 0
              }
            />
            <IconButton
              onClick={() => {
                setOpenAddEmailPopUp(true);
              }}
              label={"Add"}
              iconSize={30}
              icon={PlusCircleInactive}
              iconHover={PlusCircleHover}
              iconClicked={PlusCircleClicked}
              hideShadow={true}
              disabled={notificationMailListId == null}
            />
          </Stack>
        </Stack>
        <PopUpDataGrid
          ref={grid}
          rows={mailList}
          columns={columnsGroups}
          whiteHeader={true}
          checkboxSelection={true}
          forceDisableMultipleSelection={true}
          onSelectedRowsChange={(rows) => {
            setSelectedEmails(rows);
          }}
        />
        <div align="right" style={{ marginTop: "48px" }}>
          <Button
            disabled={isSaveBtnDisabled}
            className="btn-primary"
            style={{ width: 180, marginTop: "12px" }}
            onClick={onClickSaveGroup}
          >
            Save
          </Button>
        </div>
      </div>
    </MenuBlock>
  );
};

export default NotificationGroups;
